import DocumentForms from "./forms";
import { documentUseMutation } from "./hooks";

const Document = {
  Forms: DocumentForms,
  Hooks: documentUseMutation,
};

export default Document;
